export default "/_next/static/images/b5a2d1198e338bbae6f3ecad8c3a2e66.jpg";